export function Footer() {
  return (
    <footer className="bg-gray-100 text-gray-600 py-4 mt-8">
      <div className="container mx-auto text-center">
        <p>&copy; 2023 Post Management System. All rights reserved.</p>
      </div>
    </footer>
  )
}
